import { createAction } from '@reduxjs/toolkit';

const pageChanged = createAction('app/pageChanged');

export { pageChanged };
